import React from 'react';

import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';

import { FriesSvg as UnauthenticatedEmptyStateImage } from '../../../../../components/svgs/fries';

import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const LoggedOutEmptyState = () => {
  const { openSignInModal } = useAuthContext();

  const onPress = () => {
    openSignInModal();
  };

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <UnauthenticatedEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('unauthenticatedRecentItemsHeader')}</HeaderText>
      <SubText>{t('unauthenticatedRecentItemsSubtext')}</SubText>
      <StyledActionButtonLink onPress={onPress}>{t('logIn')}</StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default LoggedOutEmptyState;
